import { render, staticRenderFns } from "./EmployeeFRSO.vue?vue&type=template&id=73c36524&scoped=true&"
import script from "./EmployeeFRSO.vue?vue&type=script&lang=ts&"
export * from "./EmployeeFRSO.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73c36524",
  null
  
)

export default component.exports